module.exports = global["jQuery"] = require("-!/vagrant/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 478
// module chunks = 2